(function () {
  var quiz = document.getElementById('rl-quiz');
  if (!quiz) return;

  var defaultHandle    = (quiz.dataset.defaultHandle || '').trim();
  var defaultVariantId = (quiz.dataset.defaultVariantId || '').trim();
  var recsHandle       = (quiz.dataset.recsCollection || '').trim();
  var defaultPolicy    = (quiz.dataset.defaultVariantPolicy    || 'hide_trial').trim();
  var additionalPolicy = (quiz.dataset.additionalVariantPolicy || 'hide_trial').trim();
  // Parse upsell entries: "handle:variantId,handle:variantId" (variantId optional).
  var upsellHandles    = (quiz.dataset.upsellHandles || '').split(',').map(function (s) {
    var parts = s.trim().split(':');
    var handle = (parts[0] || '').trim();
    var variantId = (parts[1] || '').trim();
    return handle ? { handle: handle, variantId: variantId } : null;
  }).filter(Boolean);
  var minCheckoutTotal = parseFloat(quiz.dataset.minCheckoutTotal || '0') || 0;
  var minCheckoutMsgTpl = quiz.dataset.minCheckoutMessage || 'Add [remaining] more to qualify for checkout (minimum order [minimum])';
  var TOTAL_PRODUCT_CAP = 4;
  var MAX_UPSELL_COUNT  = 3;

  var steps          = Array.from(quiz.querySelectorAll('.rl-step'));
  var progressEl     = document.getElementById('rl-progress');
  var progressBar    = document.getElementById('rl-progress-bar');
  var progressLabel  = document.getElementById('rl-progress-label');
  var progressPct    = document.getElementById('rl-progress-pct');
  var nextBtn        = document.getElementById('rl-next');
  var backBtn        = document.getElementById('rl-back');
  var startBtn       = document.getElementById('rl-start');
  var nameInput      = document.getElementById('rl-name-input');
  var welcomeConsent = document.getElementById('rl-welcome-consent');
  var welcomeConsentErr = document.getElementById('rl-welcome-consent-error');
  var CONSENT_PROMPT = 'Please tick the box above to continue.';
  var SUBSCRIBE_TIMEOUT_MS = 10000;  // abort the Klaviyo subscribe if it hangs
  var errorEl        = document.getElementById('rl-error');
  var navEl          = document.getElementById('rl-nav');
  var trustStrip     = document.getElementById('rl-trust-strip');
  var resultsContent = document.getElementById('rl-results-content');
  var stickyCta      = document.getElementById('rl-sticky-cta');
  var stickyCtaWrap  = document.getElementById('rl-sticky-cta-wrap') || stickyCta;
  var stickyCheckout = document.getElementById('rl-sticky-checkout');
  var realCheckout   = quiz.querySelector('[data-quiz-checkout-target="button"]');
  var stickyScrollHandler = null;
  var restartBtn     = document.getElementById('rl-restart');
  var loadList       = document.getElementById('rl-loadlist');

  var welcomeStep = quiz.querySelector('[data-step="welcome"]');
  var affirmationStep = quiz.querySelector('[data-step="affirmation"]');
  var affirmationImg  = document.getElementById('rl-affirmation-img');
  var affirmationDesc = document.getElementById('rl-affirmation-desc');
  var emailStep    = quiz.querySelector('[data-step="email"]');
  var emailBackBtn   = document.getElementById('rl-email-back');
  var emailForm      = document.getElementById('rl-email-form');
  var emailInput     = document.getElementById('rl-email-input');
  var emailFormErr   = document.getElementById('rl-email-form-error');
  var emailSubmitBtn = document.getElementById('rl-email-submit');
  var emailHoneypot  = document.getElementById('rl-email-hp');
  var emailConsent   = document.getElementById('rl-email-consent');
  var emailConsentErr = document.getElementById('rl-email-consent-error');
  var emailSubmitting = false;  // guards against double-submit while subscribing
  var klaviyoPublicKey = (quiz.dataset.klaviyoPublicKey || '').trim();
  var klaviyoListId = (quiz.dataset.klaviyoListId || '').trim();
  var customerEmail = (quiz.dataset.customerEmail || '').trim();
  var capturedFormEmail = '';   // email typed into the Klaviyo form, captured on submit
  var identifiedInKlaviyo = false; // guard: only identify once per completion
  var quizSubmitted = false;       // guard: only run the completion flow once
  var emailRequested = false;      // true only when the visitor submits the email form;
                                   // gates the flow-trigger event so skipping never emails
  var flowSteps = steps.filter(function (s) {
    return !s.classList.contains('rl-step--exit')
        && !s.classList.contains('rl-step--final')
        && !s.classList.contains('rl-step--results')
        && !s.classList.contains('rl-step--affirmation')
        && !s.classList.contains('rl-step--email')
        && !s.classList.contains('rl-step--intro')
        && s.dataset.step !== 'welcome';
  });
  var introStep         = quiz.querySelector('[data-step="intro"]');
  var introContinueBtn  = document.getElementById('rl-intro-continue');
  var pendingCardsHTML  = null;

  var currentIdx = 0;
  var onWelcome = true;
  var showingAffirmation = false;

  // ----- Validation -----
  function isStepValid(stepEl) {
    if (!stepEl) return true;
    if (stepEl.dataset.required !== 'true') return true;
    var inputs = stepEl.querySelectorAll('input[type="checkbox"], input[type="radio"]');
    var checkedCount = 0;
    inputs.forEach(function (i) { if (i.checked) checkedCount++; });
    var min = parseInt(stepEl.dataset.min || '1', 10);
    return checkedCount >= min;
  }

  function refreshNextBtn() {
    if (onWelcome || showingAffirmation) return;
    nextBtn.disabled = !isStepValid(flowSteps[currentIdx]);
  }

  // ----- Navigation -----
  function showWelcome() {
    onWelcome = true;
    showingAffirmation = false;
    hideStickyCta();
    steps.forEach(function (s) { s.classList.remove('rl-step--active'); });
    welcomeStep.classList.add('rl-step--active');
    progressEl.hidden = true;
    navEl.hidden = true;
    if (trustStrip) trustStrip.style.display = '';
    quiz.classList.remove('rl-quiz--results-active');
    document.body.classList.remove('rl-quiz--results-active');
    quiz.classList.remove('rl-quiz--hide-header');
  }

  function showStep(idx) {
    onWelcome = false;
    showingAffirmation = false;
    hideStickyCta();
    steps.forEach(function (s) { s.classList.remove('rl-step--active'); });
    flowSteps[idx].classList.add('rl-step--active');
    quiz.classList.remove('rl-quiz--hide-header');
    backBtn.disabled = false;
    nextBtn.textContent = idx === flowSteps.length - 1 ? 'See my matches' : 'Continue';

    var pct = Math.round(((idx + 1) / flowSteps.length) * 100);
    progressBar.style.width = pct + '%';
    if (progressLabel) progressLabel.textContent = 'STEP ' + (idx + 1) + '/' + flowSteps.length;
    if (progressPct) progressPct.textContent = pct + '%';
    progressEl.hidden = false;

    errorEl.textContent = '';
    navEl.hidden = false;
    if (trustStrip) trustStrip.style.display = '';
    refreshNextBtn();
    scrollToQuizTop();
  }

  // Scroll the viewport so the quiz container's top is in view when a new
  // step is shown. Smooth on supporting browsers, instant otherwise.
  function scrollToQuizTop() {
    if (!quiz) return;
    var top = quiz.getBoundingClientRect().top + window.pageYOffset - 20;
    if (top < window.pageYOffset) {
      window.scrollTo({ top: top, behavior: 'smooth' });
    }
  }

  function showTerminal(stepName) {
    onWelcome = false;
    hideStickyCta();
    steps.forEach(function (s) { s.classList.remove('rl-step--active'); });
    var target = quiz.querySelector('[data-step="' + stepName + '"]');
    if (target) target.classList.add('rl-step--active');
    navEl.hidden = true;
    progressEl.hidden = true;
    if (trustStrip) trustStrip.style.display = '';
    quiz.classList.toggle('rl-quiz--results-active', stepName === 'results');
    document.body.classList.toggle('rl-quiz--results-active', stepName === 'results');
    // Hide the static "Wellness Quiz" page header on terminal steps that
    // bring their own headline (intro, email, results, loading).
    var hideHeader = stepName === 'intro' || stepName === 'email' || stepName === 'results' || stepName === 'loading';
    quiz.classList.toggle('rl-quiz--hide-header', hideHeader);
    scrollToQuizTop();
  }

  // ----- Answers -----
  // Each step has a tag_mode ('add' | 'remove') from the JSON template,
  // surfaced as data-tag-mode on the step element. Selected tags are kept
  // per-step so we can serialize, restore, and reason about provenance.
  //
  // Add-tag from one step + remove-tag from another -> tag is dropped.
  // Same tag selected multiple times in add-steps accumulates a stronger
  // signal for scoring.
  // Only quiz_-prefixed tags participate in scoring. Products opt into the
  // quiz by carrying a quiz_* tag; generic catalog tags (Active, skin, …)
  // are ignored so they can't accidentally skew recommendations.
  function parseTags(input) {
    var raw = (input.dataset.tags || '').trim();
    if (!raw) return [];
    return raw.split(',')
      .map(function (t) { return t.trim(); })
      .filter(function (t) { return t.indexOf('quiz_') === 0; });
  }

  function getStepOptions(stepEl) {
    return stepEl.querySelectorAll('input[type="checkbox"], input[type="radio"]');
  }

  // { [stepKey]: { type: 'add'|'remove', list: [tag, tag, ...] } }
  function collectAnswers() {
    var answers = {};
    flowSteps.forEach(function (step) {
      var key = step.dataset.step || '';
      var type = step.dataset.tagMode === 'remove' ? 'remove' : 'add';
      var list = [];
      getStepOptions(step).forEach(function (input) {
        if (!input.checked) return;
        parseTags(input).forEach(function (tag) { list.push(tag); });
      });
      answers[key] = { type: type, list: list };
    });
    return answers;
  }

  function answersToTagCounts(answers) {
    var addTags = [];
    var removeTags = [];
    Object.keys(answers).forEach(function (key) {
      var entry = answers[key];
      var bucket = entry.type === 'remove' ? removeTags : addTags;
      entry.list.forEach(function (tag) { bucket.push(tag); });
    });
    var counts = new Map();
    addTags.forEach(function (tag) {
      if (removeTags.indexOf(tag) !== -1) return;
      counts.set(tag, (counts.get(tag) || 0) + 1);
    });
    return counts;
  }

  // Final tag list for Klaviyo: the net add-tags (removes already subtracted by
  // answersToTagCounts), with the internal "quiz_" prefix stripped and deduped.
  // e.g. quiz_skin + quiz_menopause -> ['skin', 'menopause']. Capped defensively.
  var MAX_QUIZ_TAGS = 50;
  function buildQuizTags() {
    var counts = answersToTagCounts(collectAnswers());
    var tags = [];
    counts.forEach(function (_count, tag) {
      var clean = tag.indexOf('quiz_') === 0 ? tag.slice(5) : tag;
      if (clean && tags.indexOf(clean) === -1) tags.push(clean);
    });
    return tags.slice(0, MAX_QUIZ_TAGS);
  }

  // ----- Persistence -----
  // URL format: ?a=stepKey:optionId,optionId|stepKey:optionId|...
  // optionId is the numeric ID of the quiz_option metaobject entry
  // (option.system.id in Liquid), emitted as data-option-id on each input.
  // Stable across reorder, label rename, tag edit, and even handle/name
  // changes; only breaks if the merchant deletes and recreates the entry.
  var STORAGE_KEY = 'rl-quiz-answers';
  var URL_PARAM = 'a';
  var EDIT_PARAM = 'edit';

  function encodeSelection() {
    var parts = [];
    flowSteps.forEach(function (step) {
      var key = step.dataset.step || '';
      var ids = [];
      getStepOptions(step).forEach(function (input) {
        if (!input.checked) return;
        var id = input.dataset.optionId;
        if (id) ids.push(id);
      });
      if (ids.length) parts.push(key + ':' + ids.join(','));
    });
    return parts.join('|');
  }

  function decodeSelection(str) {
    var out = {};
    if (!str) return out;
    str.split('|').forEach(function (part) {
      var seg = part.split(':');
      if (seg.length !== 2) return;
      var ids = seg[1].split(',')
        .map(function (s) { return s.trim(); })
        .filter(Boolean);
      if (ids.length) out[seg[0]] = ids;
    });
    return out;
  }

  function applySelection(selection) {
    flowSteps.forEach(function (step) {
      var key = step.dataset.step || '';
      var ids = selection[key];
      if (!ids) return;
      ids.forEach(function (id) {
        var input = step.querySelector('input[data-option-id="' + CSS.escape(id) + '"]');
        if (input) input.checked = true;
      });
    });
  }

  function saveAnswers() {
    var encoded = encodeSelection();
    if (!encoded) return;
    try {
      var url = new URL(window.location.href);
      url.searchParams.set(URL_PARAM, encoded);
      url.searchParams.delete(EDIT_PARAM);
      window.history.replaceState({}, '', url.toString());
    } catch (e) { /* ignore */ }
    try { localStorage.setItem(STORAGE_KEY, encoded); } catch (e) { /* ignore */ }
  }

  function loadAnswers() {
    var params = new URLSearchParams(window.location.search);
    var fromUrl = params.get(URL_PARAM);
    if (fromUrl) {
      return { encoded: fromUrl, source: 'url', editMode: params.get(EDIT_PARAM) === '1' };
    }
    try {
      var fromLocal = localStorage.getItem(STORAGE_KEY);
      if (fromLocal) return { encoded: fromLocal, source: 'local', editMode: true };
    } catch (e) { /* ignore */ }
    return null;
  }

  function clearAnswers() {
    try {
      var url = new URL(window.location.href);
      url.searchParams.delete(URL_PARAM);
      url.searchParams.delete(EDIT_PARAM);
      window.history.replaceState({}, '', url.toString());
    } catch (e) { /* ignore */ }
    try { localStorage.removeItem(STORAGE_KEY); } catch (e) { /* ignore */ }
  }

  // ----- Recommendations source -----
  function fetchCollectionProducts(handle) {
    var url = '/collections/' + encodeURIComponent(handle) + '/products.json?limit=250';
    return fetch(url, { headers: { 'Accept': 'application/json' } })
      .then(function (r) {
        if (!r.ok) throw new Error('products.json returned ' + r.status);
        return r.json();
      })
      .then(function (data) {
        return (data.products || []).map(function (p) {
          var tags = p.tags;
          if (typeof tags === 'string') {
            tags = tags.split(',').map(function (s) { return s.trim(); }).filter(Boolean);
          } else if (!Array.isArray(tags)) {
            tags = [];
          }
          return { handle: p.handle, tags: tags };
        });
      });
  }

  function scoreAndPick(products, userTagCounts, excludeHandle, limit, excludeTags) {
    var excludeSet = new Set(excludeTags || []);
    // If the user selected a quiz_menopause option, products carrying the
    // quiz_menopause tag jump to the top of the list regardless of score.
    var prioritizeMenopause = userTagCounts.has('quiz_menopause');
    return products
      .filter(function (p) {
        // Drop products that carry any tag in excludeSet
        // (e.g. quiz_menopause when the user isn't quiz_female).
        if (excludeSet.size === 0) return true;
        for (var i = 0; i < p.tags.length; i++) {
          if (excludeSet.has(p.tags[i])) return false;
        }
        return true;
      })
      .map(function (p, idx) {
        var score = 0;
        var hasMenopause = false;
        for (var i = 0; i < p.tags.length; i++) {
          score += userTagCounts.get(p.tags[i]) || 0;
          if (p.tags[i] === 'quiz_menopause') hasMenopause = true;
        }
        return { handle: p.handle, score: score, hasMenopause: hasMenopause, idx: idx };
      })
      .filter(function (p) { return p.handle && p.handle !== excludeHandle && p.score > 0; })
      .sort(function (a, b) {
        // Tier 1: quiz_menopause-tagged products first (when user selected it).
        if (prioritizeMenopause && a.hasMenopause !== b.hasMenopause) {
          return a.hasMenopause ? -1 : 1;
        }
        // Tier 2: higher tag-overlap score.
        if (b.score !== a.score) return b.score - a.score;
        // Tier 3: original collection order as the final tie-breaker.
        return a.idx - b.idx;
      })
      .slice(0, limit)
      .map(function (p) { return p.handle; });
  }

  function extractCardWrapper(html) {
    if (!html) return '';
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var card = doc.querySelector('.product-quiz-card, .product-card-wrapper');
    return card ? card.outerHTML : '';
  }

  // Server-renders one card. Each policy has its own template suffix
  // (request.url query params don't survive the Section Render API, so the
  // policy can't be passed at runtime - it has to live in the template).
  var POLICY_VIEW = {
    all:        'quiz-card',
    hide_trial: 'quiz-card-hide-trial',
    subs_only:  'quiz-card-subs',
    otp_only:   'quiz-card-otp'
  };
  function fetchCard(handle, variantId, policy) {
    if (!handle) return Promise.resolve('');
    var view = POLICY_VIEW[policy] || 'quiz-card';
    var url = '/products/' + encodeURIComponent(handle) + '?view=' + view;
    if (variantId) url += '&variant=' + encodeURIComponent(variantId);
    // console.log('[rl-quiz] fetchCard → policy=' + policy + ' view=' + view + ' url=' + url);
    return fetch(url, { headers: { 'Accept': 'text/html' } })
      .then(function (r) {
        if (!r.ok) {
          console.warn('[rl-quiz] Card fetch failed for "' + handle + '":', r.status);
          return '';
        }
        return r.text();
      })
      .then(function (html) {
        return extractCardWrapper(html);
      })
      .catch(function (err) {
        console.error('[rl-quiz] Card fetch error for "' + handle + '":', err);
        return '';
      });
  }

  // Build "You told us {prefix1} {labels1}, {prefix2} {labels2}, …" from the
  // checked options on each step. Per-step prefix comes from data-summary-prefix
  // on the step section (set via the block's "summary_prefix" setting).
  function joinHuman(arr) {
    if (arr.length === 0) return '';
    if (arr.length === 1) return arr[0];
    return arr.slice(0, -1).join(', ') + ' and ' + arr[arr.length - 1];
  }

  function buildAnswerSummary() {
    // Sort by `data-summary-order` (ascending) so the merchant controls the
    // narrative order independent of the quiz flow. Steps without an order
    // fall back to their flow position, appended after explicit orders.
    var ordered = flowSteps.slice().map(function (step, idx) {
      var raw = step.dataset.summaryOrder;
      var order = (raw === undefined || raw === '') ? Infinity : parseInt(raw, 10);
      if (isNaN(order)) order = Infinity;
      return { step: step, order: order, idx: idx };
    }).sort(function (a, b) {
      return a.order - b.order || a.idx - b.idx;
    });

    var parts = [];
    ordered.forEach(function (entry) {
      var step = entry.step;
      var prefix = (step.dataset.summaryPrefix || '').trim();
      // Use each option's `recommendation` field (emitted as data-recommendation
      // from the quiz_option metaobject). Options without a recommendation
      // value are silently skipped — i.e. they don't appear in the summary at all.
      // Duplicates are collapsed (case-insensitive) so two options sharing the
      // same recommendation string don't show up twice in the same sentence.
      // "Prefer not to say" is treated as a non-answer and dropped entirely.
      var labels = [];
      var seenLabels = {};
      getStepOptions(step).forEach(function (input) {
        if (!input.checked) return;
        var recommendation = (input.dataset.recommendation || '').trim();
        if (!recommendation) return;
        var key = recommendation.toLowerCase();
        if (key === 'prefer not to say') return;
        if (seenLabels[key]) return;
        seenLabels[key] = true;
        labels.push(recommendation);
      });
      if (!labels.length) return;
      var joined = joinHuman(labels);
      parts.push(prefix ? prefix + ' ' + joined : joined);
    });
    if (!parts.length) return '';
    var intro = (quiz.dataset.resultSummaryIntro || 'You told us').trim();
    // Escape once at the boundary so any downstream use in this function
    // is safe by default. The summary string is concatenated into HTML
    // by renderResults via innerHTML.
    var name = escapeHtml(getQuizName());
    if (name) {
      intro = name + ', ' + intro.charAt(0).toLowerCase() + intro.slice(1);
    }
    return intro + ' ' + joinHuman(parts) + '.';
  }

  function renderResults(payload) {
    // Accept the new {main, upsell} shape or the legacy flat array.
    var mainCards, upsellCards;
    if (payload && typeof payload === 'object' && !Array.isArray(payload)) {
      mainCards   = (payload.main || []).filter(Boolean);
      upsellCards = (payload.upsell || []).filter(Boolean);
    } else {
      mainCards = (payload || []).filter(Boolean);
      upsellCards = [];
    }
    var allCards = mainCards.concat(upsellCards);
    if (!allCards.length) {
      resultsContent.innerHTML = '<div class="rl-error-box">'
        + '<p>We couldn\'t load product recommendations right now.</p>'
        + '<p style="margin-top: 0.75rem;"><a href="/collections/all" class="rl-link">Browse all products instead</a></p>'
        + '</div>';
      return;
    }
    var summary = buildAnswerSummary();
    var recommendation = quiz.dataset.resultRecommendation || '';
    var subHTML = '';
    if (summary) {
      subHTML += '<p class="rl-result-sub rl-result-sub--summary">' + summary + '</p>';
    }
    if (recommendation) {
      subHTML += '<div class="rl-result-sub rl-result-sub--recommendation">' + recommendation + '</div>';
    }
    var introHTML = '<div class="tw:text-center tw:mb-7 tw:max-w-[720px] tw:mx-auto">'
      + '<h2 class="rl-result-title">Your Personalised Youth-Boost Routine Is Ready</h2>'
      + subHTML
      + '</div>';
    var gridOpen  = '<div class="product-grid-custom product-grid-custom-reusable col-grid-4"><div class="product-grid-custom-inner">';
    var gridClose = '</div></div>';
    var splitHTML = gridOpen + mainCards.join('') + gridClose;
    if (upsellCards.length) {
      splitHTML += '<h3 class="rl-result-supercharge">Supercharge Your Results</h3>'
                +  gridOpen + upsellCards.join('') + gridClose;
    }
    resultsContent.innerHTML = introHTML + splitHTML;

    // Pre-add only the MAIN cards (default + best match) to the bundle.
    // Upsells (rendered after the "Supercharge Your Results" heading) are
    // opt-in - the customer must explicitly click ATC to include them.
    var preselect = resultsContent.querySelectorAll('.product-quiz-card');
    for (var i = 0; i < Math.min(mainCards.length, preselect.length); i++) {
      preselect[i].classList.add('is-added');
    }

    applyVariantAvailability();
    setupStickyCta();
    updateCheckoutPrices();

    // Re-sum prices whenever a card's ATC toggles or a variant changes.
    if (!resultsContent.dataset.priceListenersBound) {
      resultsContent.addEventListener('click', function (e) {
        if (e.target.closest('[data-quiz-card-atc]')) {
          // is-added class toggle happens on the same click; defer to next tick.
          setTimeout(updateCheckoutPrices, 0);
        }
      });
      resultsContent.addEventListener('change', function (e) {
        var sel = e.target;
        if (!sel.matches || !sel.matches('select[data-variant-select]')) return;
        // Push the new variant's compare-at into the card BEFORE summing
        // (the quiz_checkout controller only updates the now-price element).
        var card = sel.closest('.product-quiz-card');
        var opt = sel.options[sel.selectedIndex];
        if (card && opt) {
          var wasEl = card.querySelector('.product-quiz-card__price-was');
          if (wasEl) {
            var compare = opt.dataset.compareAtPrice || '';
            wasEl.textContent = compare;
            wasEl.style.display = compare ? '' : 'none';
          }
        }
        // Defer so the controller's updateCardPrice runs first (also a
        // bubble listener; order depends on registration).
        setTimeout(updateCheckoutPrices, 0);
      });
      resultsContent.dataset.priceListenersBound = '1';
    }
  }

  // The variant-policy filter is now applied server-side in product-quiz-card.liquid
  // (using the section's default_/additional_product_variant_policy settings).
  // The only client-side dynamic filtering left is availability: hide a value
  // whose combination with the currently-selected other options has no variant.
  function applyVariantAvailability() {
    var cards = resultsContent.querySelectorAll('.product-quiz-card');
    cards.forEach(function (card) {
      updateVariantAvailability(card);

      // After the availability filter has hidden any unreachable values,
      // re-apply Liquid's render rules dynamically:
      //  - any option group reduced to ≤1 visible value is hidden completely
      //  - if no group remains, hide the picker entirely
      //  - if exactly one group remains visible, drop its label
      var pickerEl = card.querySelector('.product-quiz-card__options');
      var allOpts = card.querySelectorAll('.product-quiz-card__option');
      allOpts.forEach(function (optEl) {
        var grp = optEl.querySelector('.product-quiz-card__option-values');
        var btns = grp ? Array.from(grp.querySelectorAll('.product-quiz-card__option-value')).filter(function (b) { return !b.hidden; }) : [];
        if (btns.length <= 1) optEl.hidden = true;
      });
      var visibleOpts = Array.from(allOpts).filter(function (o) { return !o.hidden; });
      if (pickerEl && visibleOpts.length === 0) {
        pickerEl.hidden = true;
      } else if (visibleOpts.length === 1) {
        var nameEl = visibleOpts[0].querySelector('.product-quiz-card__option-name');
        if (nameEl) nameEl.hidden = true;
      }
    });
  }

  // Visible button click -> mark button active, find matching <option> in the
  // hidden select by comparing option1/2/3 values, set it selected, fire
  // `change` so the quiz-checkout Stimulus controller updates price/image/id.
  function syncVariantPicker(btn) {
    var card = btn.closest('.product-quiz-card');
    if (!card) return;
    var group = btn.parentElement;

    Array.from(group.querySelectorAll('.product-quiz-card__option-value')).forEach(function (b) {
      var isActive = b === btn;
      b.classList.toggle('is-selected', isActive);
      b.setAttribute('aria-checked', isActive ? 'true' : 'false');
    });

    var selectedByPos = {};
    card.querySelectorAll('.product-quiz-card__option').forEach(function (optEl) {
      var pos = optEl.dataset.optionPosition;
      var active = optEl.querySelector('.product-quiz-card__option-value.is-selected');
      if (active) selectedByPos[pos] = active.dataset.optionValue;
    });

    var select = card.querySelector('select[data-variant-select]');
    if (!select) return;
    var matched = Array.from(select.options).find(function (opt) {
      return ['1', '2', '3'].every(function (i) {
        var sel = selectedByPos[i];
        if (sel === undefined || sel === '') return true;
        return (opt.dataset['option' + i] || '') === sel;
      });
    });
    if (matched) {
      matched.selected = true;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }
    updateVariantAvailability(card);
  }

  // For each option-value button, unhide if at least one variant exists whose
  // pos-N value equals this button's value AND whose values for the OTHER
  // positions equal the currently-selected values. Otherwise hide.
  function updateVariantAvailability(card) {
    var select = card.querySelector('select[data-variant-select]');
    if (!select) return;
    var variants = Array.from(select.options);

    var selectedByPos = {};
    card.querySelectorAll('.product-quiz-card__option').forEach(function (optEl) {
      var pos = optEl.dataset.optionPosition;
      var active = optEl.querySelector('.product-quiz-card__option-value.is-selected');
      if (active) selectedByPos[pos] = active.dataset.optionValue;
    });

    card.querySelectorAll('.product-quiz-card__option-value').forEach(function (btn) {
      var btnPos = btn.dataset.optionPosition;
      var btnVal = btn.dataset.optionValue;
      var exists = variants.some(function (opt) {
        if ((opt.dataset['option' + btnPos] || '') !== btnVal) return false;
        return ['1', '2', '3'].every(function (i) {
          if (i === btnPos) return true;
          var sel = selectedByPos[i];
          if (sel === undefined || sel === '') return true;
          return (opt.dataset['option' + i] || '') === sel;
        });
      });
      btn.hidden = !exists;
    });
  }

  if (resultsContent) {
    resultsContent.addEventListener('click', function (e) {
      var btn = e.target.closest('.product-quiz-card__option-value');
      if (btn) {
        e.preventDefault();
        syncVariantPicker(btn);
      }
    });
  }

  // Sum the now-prices and compare-at prices across every .is-added card and
  // write the totals into the [data-static-purchase-target] elements in both
  // the static .rl-results-cta and the sticky bar. Re-run after the cards
  // render and on every variant change / ATC toggle.
  function updateCheckoutPrices() {
    var resultsStep = quiz.querySelector('[data-step="results"]');
    if (!resultsStep) return;
    var added = resultsContent.querySelectorAll('.product-quiz-card.is-added');
    var nowSum = 0;
    var wasSum = 0;
    var currencySym = '£';
    added.forEach(function (card) {
      var nowEl = card.querySelector('[data-card-price]');
      var wasEl = card.querySelector('.product-quiz-card__price-was');
      if (nowEl && nowEl.textContent) {
        var sym = (nowEl.textContent.match(/[^\d\s.,]+/) || [])[0];
        if (sym) currencySym = sym;
        nowSum += parseMoney(nowEl.textContent);
      }
      if (wasEl && wasEl.textContent) wasSum += parseMoney(wasEl.textContent);
      else if (nowEl && nowEl.textContent) wasSum += parseMoney(nowEl.textContent);
    });
    var nowStr = currencySym + nowSum.toFixed(2);
    var wasStr = currencySym + wasSum.toFixed(2);
    var savedAmount = wasSum - nowSum;
    var savedStr = currencySym + (savedAmount > 0 ? savedAmount : 0).toFixed(2);
    var showWas = wasSum > nowSum + 0.001;

    // Update the now-price in both static + sticky.
    [resultsStep, stickyCta].forEach(function (root) {
      if (!root) return;
      var priceEl = root.querySelector('[data-static-purchase-target="price"]');
      if (priceEl) priceEl.textContent = nowStr;
    });

    // Static ATC: "You saved <amount>" instead of struck-through compare.
    if (resultsStep) {
      var savingsRow = resultsStep.querySelector('[data-static-purchase-target="savings"]');
      var savingsAmt = resultsStep.querySelector('[data-static-purchase-target="savingsAmount"]');
      if (savingsRow) savingsRow.hidden = !showWas;
      if (savingsAmt) savingsAmt.textContent = savedStr;
    }

    // Sticky ATC: struck-through compare-at (legacy behavior).
    if (stickyCta) {
      var stickyWas = stickyCta.querySelector('[data-static-purchase-target="compareAtPrice"]');
      if (stickyWas) {
        stickyWas.textContent = wasStr;
        var wasRow = stickyWas.closest('p');
        if (wasRow) wasRow.style.display = showWas ? '' : 'none';
      }
    }

    // Below-threshold gate: disable both checkout buttons + show message.
    // Applies whenever the bundle total is under the minimum, including £0.
    var below = minCheckoutTotal > 0 && nowSum + 0.001 < minCheckoutTotal;
    var remaining = minCheckoutTotal - nowSum;
    var remainingStr = currencySym + (remaining > 0 ? remaining : 0).toFixed(2);
    var minStr = currencySym + minCheckoutTotal.toFixed(2);
    var msg = minCheckoutMsgTpl
      .replace(/\[remaining\]/g, remainingStr)
      .replace(/\[minimum\]/g, minStr);

    var staticBtn = resultsStep && resultsStep.querySelector('[data-quiz-checkout-target="button"]');
    function setDisabled(btn) {
      if (!btn) return;
      btn.classList.toggle('is-disabled', below);
      if (below) {
        btn.setAttribute('aria-disabled', 'true');
      } else {
        btn.removeAttribute('aria-disabled');
      }
    }
    setDisabled(staticBtn);
    setDisabled(stickyCheckout);

    var staticMsg = document.getElementById('rl-min-order-msg');
    var stickyMsg = document.getElementById('rl-min-order-msg-sticky');
    [staticMsg, stickyMsg].forEach(function (el) {
      if (!el) return;
      el.textContent = msg;
      el.hidden = !below;
    });
  }

  function parseMoney(str) {
    if (!str) return 0;
    var cleaned = str.replace(/[^\d.,-]/g, '').replace(/,/g, '');
    var n = parseFloat(cleaned);
    return isNaN(n) ? 0 : n;
  }

  // The separate sticky bar shows once the viewport's bottom edge is below the
  // first result card's bottom border (i.e. you've scrolled past that card's
  // bottom). The static .rl-results-cta in the results flow is untouched.
  function setupStickyCta() {
    if (!stickyCtaWrap) return;
    var firstCard = resultsContent.querySelector('.product-quiz-card');
    if (!firstCard) { stickyCtaWrap.hidden = false; return; }

    var ticking = false;
    function update() {
      ticking = false;
      var rect = firstCard.getBoundingClientRect();
      stickyCtaWrap.hidden = !(rect.bottom < window.innerHeight - 50);
    }
    stickyScrollHandler = function () {
      if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
    };
    window.addEventListener('scroll', stickyScrollHandler, { passive: true });
    window.addEventListener('resize', stickyScrollHandler);
    update();
  }

  // Hide the sticky bar and detach its scroll listener — used when leaving results.
  function hideStickyCta() {
    if (stickyScrollHandler) {
      window.removeEventListener('scroll', stickyScrollHandler);
      window.removeEventListener('resize', stickyScrollHandler);
      stickyScrollHandler = null;
    }
    if (stickyCtaWrap) stickyCtaWrap.hidden = true;
  }

  function renderError() {
    resultsContent.innerHTML = '<div class="rl-error-box">'
      + '<p>We couldn\'t load product recommendations right now. Please try again in a moment.</p>'
      + '<p style="margin-top: 0.75rem;"><a href="/collections/all" class="rl-link">Browse all products instead</a></p>'
      + '</div>';
  }

  // ----- Loading checklist animation -----
  function animateLoadList() {
    if (!loadList) return Promise.resolve();
    var items = Array.from(loadList.querySelectorAll('li'));
    items.forEach(function (i) { i.classList.remove('is-done', 'is-active'); });
    if (items[0]) items[0].classList.add('is-active');

    var stepDelay = 600;
    return new Promise(function (resolve) {
      function tick(i) {
        if (i >= items.length) { resolve(); return; }
        items[i].classList.remove('is-active');
        items[i].classList.add('is-done');
        if (items[i + 1]) items[i + 1].classList.add('is-active');
        setTimeout(function () { tick(i + 1); }, stepDelay);
      }
      setTimeout(function () { tick(0); }, stepDelay);
    });
  }

  // isRestore = true when re-running for a shared results URL (?a=...), not a
  // genuine completion by this visitor — in that case we must NOT identify them
  // in Klaviyo (the encoded answers may belong to whoever shared the link).
  function submitQuiz(isRestore) {
    // Guard against double submission (e.g. the Klaviyo form firing 'submit'
    // twice, or a rapid Skip + submit) — only run the completion flow once.
    if (quizSubmitted) return;
    quizSubmitted = true;
    var answers = collectAnswers();
    var userTagCounts = answersToTagCounts(answers);
    saveAnswers();
    // console.log('[rl-quiz] Answers:', answers);
    // console.log('userTagCounts:', userTagCounts);
    // console.log('[rl-quiz] User tag counts:', Object.fromEntries(userTagCounts));
    showTerminal('loading');

    var minWait = animateLoadList();

    // Tag-based product exclusions:
    //  - quiz_menopause is only relevant if the user identified as female.
    var excludeProductTags = [];
    if (!userTagCounts.has('quiz_female')) excludeProductTags.push('quiz_menopause');

    // Main bundle = default product + top-1 tag-matched recommendation.
    var mainHandlesPromise = recsHandle
      ? fetchCollectionProducts(recsHandle)
          .then(function (products) {
            var picks = scoreAndPick(products, userTagCounts, defaultHandle, 1, excludeProductTags);
            // console.log('[rl-quiz] Main picks:', picks);
            return [defaultHandle].concat(picks).filter(Boolean);
          })
          .catch(function (err) {
            console.error('[rl-quiz] Could not load recommendations collection:', err);
            return [defaultHandle].filter(Boolean);
          })
      : Promise.resolve([defaultHandle].filter(Boolean));

    // Cap total at TOTAL_PRODUCT_CAP, with upsells capped at MAX_UPSELL_COUNT.
    var cardsPromise = mainHandlesPromise.then(function (mainHandles) {
      var mainSet = new Set(mainHandles);
      var roomForUpsell = Math.max(0, TOTAL_PRODUCT_CAP - mainHandles.length);
      var upsellSelected = upsellHandles
        .filter(function (item) { return !mainSet.has(item.handle); })  // avoid duplicates
        .slice(0, Math.min(MAX_UPSELL_COUNT, roomForUpsell));

      var mainCards = Promise.all(mainHandles.map(function (h, idx) {
        var v = (h === defaultHandle) ? defaultVariantId : '';
        var policy = (idx === 0) ? defaultPolicy : additionalPolicy;
        return fetchCard(h, v, policy);
      }));
      var upsellCards = Promise.all(upsellSelected.map(function (item) {
        return fetchCard(item.handle, item.variantId, additionalPolicy);
      }));
      return Promise.all([mainCards, upsellCards]).then(function (pair) {
        return { main: pair[0].filter(Boolean), upsell: pair[1].filter(Boolean) };
      });
    });

    Promise.all([minWait, cardsPromise])
      .then(function (results) {
        // Reached "Show my recommendations": identify + store quiz tags in Klaviyo.
        // Skipped for shared-link restores (not this visitor's own answers).
        if (!isRestore) identifyInKlaviyo();
        if (introStep) {
          pendingCardsHTML = results[1];
          personalizeIntro();
          showTerminal('intro');
        } else {
          showTerminal('results');
          renderResults(results[1]);
        }
      })
      .catch(function (err) {
        console.error('[rl-quiz] Submit failed:', err);
        showTerminal('results');
        renderError();
      });
  }

  // Replace [name] in the intro message with the welcome-step name input.
  // Empty name → strip the placeholder and any surrounding "," or "!".
  function personalizeIntro() {
    var messageEl = quiz.querySelector('[data-intro-message]');
    if (messageEl) {
      var template = messageEl.dataset.template || messageEl.innerHTML;
      var name = (nameInput && nameInput.value || '').trim();
      var html = name
        ? template.replace(/\[name\]/g, escapeHtml(name))
        : template.replace(/[,!]?\s*\[name\][,!]?/g, '').replace(/\s{2,}/g, ' ').trim();
      messageEl.innerHTML = html;
    }

    // Clinical results section is only relevant when the user selected a
    // skin-related option (either quiz_skin or quiz_skincare or quiz_visible_skin_issues tag).
    var clinicalEl = quiz.querySelector('.rl-intro-clinical');
    if (clinicalEl) {
      var tagCounts = answersToTagCounts(collectAnswers());
      var skinSelected = tagCounts.has('quiz_skin') || tagCounts.has('quiz_skincare') || tagCounts.has('quiz_visible_skin_issues');
      clinicalEl.hidden = !skinSelected;
    }
  }

  function escapeHtml(s) {
    return s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  if (introContinueBtn) {
    introContinueBtn.addEventListener('click', function () {
      // Swap to the results step FIRST - showTerminal() runs hideStickyCta()
      // which would otherwise detach the listener that renderResults sets up.
      showTerminal('results');
      if (pendingCardsHTML) {
        renderResults(pendingCardsHTML);
        pendingCardsHTML = null;
      }
    });
  }

  // ----- Affirmations -----
  // Returns the affirmation of the first selected option (in render order)
  // that has image or description content, or null.
  function firstAffirmation(stepEl) {
    var options = getStepOptions(stepEl);
    for (var i = 0; i < options.length; i++) {
      if (!options[i].checked) continue;
      var image = options[i].dataset.affirmationImage || '';
      var desc = options[i].dataset.affirmationDesc || '';
      if (image || desc) return { image: image, desc: desc };
    }
    return null;
  }

  function showAffirmation(data) {
    showingAffirmation = true;
    onWelcome = false;
    steps.forEach(function (s) { s.classList.remove('rl-step--active'); });
    affirmationStep.classList.add('rl-step--active');
    if (data.image) {
      affirmationImg.src = data.image;
      affirmationImg.hidden = false;
    } else {
      affirmationImg.removeAttribute('src');
      affirmationImg.hidden = true;
    }
    affirmationDesc.textContent = data.desc || '';
    errorEl.textContent = '';
    navEl.hidden = false;
    backBtn.disabled = false;
    nextBtn.disabled = false;
    nextBtn.textContent = 'Continue';
    if (trustStrip) trustStrip.style.display = '';
  }

  function advanceFromStep() {
    if (currentIdx < flowSteps.length - 1) {
      currentIdx++;
      showStep(currentIdx);
    } else if (emailStep) {
      showEmailStep();
    } else {
      submitQuiz();
    }
  }

  // Optional, skippable step offering to email the results. The custom form
  // subscribes the email to the list (with consent) and triggers the flow on
  // submit; the visitor advances to results on success or skip.
  function showEmailStep() {
    onWelcome = false;
    showingAffirmation = false;
    hideStickyCta();
    // Re-entering the email step (e.g. coming back from results) is a fresh
    // completion attempt: clear the one-shot guards so Skip / submit work again,
    // and reset emailRequested so a later Skip can't fire the flow-trigger event
    // left enabled by a previous submit.
    quizSubmitted = false;
    identifiedInKlaviyo = false;
    emailRequested = false;
    steps.forEach(function (s) { s.classList.remove('rl-step--active'); });
    emailStep.classList.add('rl-step--active');
    navEl.hidden = true;
    progressEl.hidden = true;
    errorEl.textContent = '';
    if (emailFormErr) emailFormErr.textContent = '';
    setEmailSubmitting(false);
    if (trustStrip) trustStrip.style.display = '';
  }

  function currentResultsUrl() {
    var encoded = encodeSelection();
    if (!encoded) return window.location.href;
    return window.location.origin + window.location.pathname + '?' + URL_PARAM + '=' + encodeURIComponent(encoded);
  }

  // Identity to attach the Klaviyo profile to, by priority:
  //  1. email typed into the custom form (captured on submit)
  //  2. an already-identified onsite profile -> '' (let identify merge onto it)
  //  3. the logged-in Shopify customer email (data-customer-email fallback)
  function resolveKlaviyoEmail() {
    if (capturedFormEmail) return capturedFormEmail;
    try {
      var k = window.klaviyo;
      if (k && typeof k.isIdentified === 'function' && k.isIdentified()) return '';
    } catch (e) { /* ignore */ }
    return customerEmail || '';
  }

  // Identify the visitor in Klaviyo and store their quiz tags + results URL on
  // the profile. Fires once per completion; safe no-op if the onsite SDK isn't
  // present. Sets the same profile properties as subscribeToKlaviyoList(), so a
  // logged-in visitor who skips the email form still gets the URL on their
  // profile (not just as a track event property). Overwrites on each take.
  function identifyInKlaviyo() {
    if (identifiedInKlaviyo) return;
    var k = window.klaviyo;
    if (!k || typeof k.identify !== 'function') return;
    identifiedInKlaviyo = true;
    var tags = buildQuizTags();
    var payload = {
      quiz_tags: tags,
      results_url: currentResultsUrl()
    };
    var quizName = getQuizName();
    if (quizName) payload.name = quizName;
    var email = resolveKlaviyoEmail();
    if (email) payload.email = email;
    // identify() can return a promise on newer onsite SDKs — chain track() off it
    // so the event lands on the now-identified profile, not an anonymous one.
    var done;
    try {
      done = k.identify(payload);
    } catch (e) {
      console.warn('[rl-quiz] klaviyo.identify failed:', e);
    }
    // The flow-trigger event fires ONLY when the visitor explicitly requested the
    // email (submitted the form). Skipping must never trigger the flow — otherwise
    // an already-consented profile (e.g. a logged-in subscriber) gets emailed even
    // though they chose "No thanks". identify() above still runs on every take.
    if (!emailRequested) return;
    if (done && typeof done.then === 'function') {
      done.then(function () { trackQuizCompleted(k, tags); },
                function () { trackQuizCompleted(k, tags); });
    } else {
      trackQuizCompleted(k, tags);
    }
  }

  // Fire the custom metric event that the "Completed Wellness Quiz" flow is
  // triggered by. Delivery still depends on the profile having marketing consent
  // (track does NOT grant it) — the embedded form / existing subscription does.
  function trackQuizCompleted(k, tags) {
    if (!k || typeof k.track !== 'function') return;
    try {
      k.track('Completed Wellness Quiz', {
        quiz_tags: tags,
        results_url: currentResultsUrl(),
        name: getQuizName()
      });
    } catch (e) {
      console.warn('[rl-quiz] klaviyo.track failed:', e);
    }
  }

  // ----- Event wiring -----
  // ----- Welcome name field -----
  // Persisted separately from URL state — names shouldn't ride along in a
  // shareable results link. Restored on load, cleared on restart.
  var NAME_STORAGE_KEY = 'rl-quiz-name';

  function getQuizName() {
    return nameInput ? nameInput.value.trim() : '';
  }

  function persistQuizName() {
    if (!nameInput) return;
    try { localStorage.setItem(NAME_STORAGE_KEY, getQuizName()); } catch (e) { /* ignore */ }
  }

  function restoreQuizName() {
    if (!nameInput) return;
    try {
      var stored = localStorage.getItem(NAME_STORAGE_KEY);
      if (stored) nameInput.value = stored;
    } catch (e) { /* ignore */ }
  }

  if (nameInput) {
    nameInput.addEventListener('input', persistQuizName);
  }

  // When a consent checkbox is present, show the Start button as disabled (but
  // still clickable) until it's ticked, and clear the prompt once ticked. No-op
  // when there's no consent checkbox (welcome_consent_text blank).
  function syncStartConsent() {
    if (!startBtn || !welcomeConsent) return;
    var blocked = !welcomeConsent.checked;
    startBtn.classList.toggle('is-disabled', blocked);
    startBtn.setAttribute('aria-disabled', blocked ? 'true' : 'false');
    if (welcomeConsent.checked && welcomeConsentErr) welcomeConsentErr.textContent = '';
  }
  if (welcomeConsent) {
    welcomeConsent.addEventListener('change', syncStartConsent);
    syncStartConsent();
  }

  if (startBtn) {
    startBtn.addEventListener('click', function () {
      // Consent required but unticked → prompt to tick it (the button looks
      // disabled but stays clickable so we can show this message).
      if (welcomeConsent && !welcomeConsent.checked) {
        if (welcomeConsentErr) welcomeConsentErr.textContent = CONSENT_PROMPT;
        welcomeConsent.focus();
        return;
      }
      // Defer to the browser's native HTML5 validation (the `required` /
      // `minlength` attributes on the input). reportValidity() shows the
      // native tooltip and returns false when invalid; no JS-side error state.
      if (nameInput && !nameInput.reportValidity()) return;
      persistQuizName();
      currentIdx = 0;
      showStep(0);
    });
  }

  nextBtn.addEventListener('click', function () {
    if (showingAffirmation) {
      showingAffirmation = false;
      advanceFromStep();
      return;
    }

    var step = flowSteps[currentIdx];
    if (!isStepValid(step)) return;

    var affirmation = firstAffirmation(step);
    if (affirmation) {
      showAffirmation(affirmation);
      return;
    }

    advanceFromStep();
  });

  backBtn.addEventListener('click', function () {
    if (showingAffirmation) {
      showStep(currentIdx);
      return;
    }
    if (currentIdx > 0) {
      currentIdx--;
      showStep(currentIdx);
    } else if (!onWelcome) {
      showWelcome();
    }
  });

  restartBtn.addEventListener('click', function () {
    clearAnswers();
    quiz.querySelectorAll('input:checked').forEach(function (i) { i.checked = false; });
    if (nameInput) {
      nameInput.value = '';
      try { localStorage.removeItem(NAME_STORAGE_KEY); } catch (e) { /* ignore */ }
    }
    refreshActiveStates();
    resultsContent.innerHTML = '';
    currentIdx = 0;
    // Allow a fresh completion (re-identify + re-submit) after a restart.
    quizSubmitted = false;
    identifiedInKlaviyo = false;
    emailRequested = false;
    showWelcome();
  });

  function refreshActiveStates() {
    quiz.querySelectorAll('.rl-option').forEach(function (label) {
      var input = label.querySelector('input');
      if (!input) return;
      label.classList.toggle('active', input.checked);
    });
  }

  quiz.addEventListener('change', function () {
    errorEl.textContent = '';
    refreshNextBtn();
    refreshActiveStates();
  });

  // Card click + variant-change behavior is owned by the
  // quiz-checkout Stimulus controller (webpack/src/controllers/quiz_checkout_controller.ts).

  // Sticky bar's button proxies the real (controller-managed) checkout button,
  // so it always uses the current selection's href without duplicating logic.
  if (stickyCheckout) {
    stickyCheckout.addEventListener('click', function (e) {
      e.preventDefault();
      if (stickyCheckout.classList.contains('is-disabled')) return;
      if (!realCheckout || realCheckout.getAttribute('aria-disabled') === 'true') return;
      var href = realCheckout.getAttribute('href');
      if (href && href !== '#') window.location.href = href;
    });
  }

  // Capture-phase guard for the static checkout button: block navigation if
  // the bundle hasn't reached the minimum-order threshold. Runs before the
  // browser's default <a> navigation.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-quiz-checkout-target="button"]');
    if (!btn) return;
    if (btn.classList.contains('is-disabled')) {
      e.preventDefault();
      e.stopPropagation();
    }
  }, true);

  // Delegated (not bound directly to the element) so the "No thanks / skip"
  // action fires reliably regardless of bind timing or any DOM re-render.
  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('#rl-email-skip')) {
      e.preventDefault();
      submitQuiz();
    }
  });

  // Back button on the email step - returns the user to the last question so
  // they can adjust answers; the in-flow nav/progress is restored by showStep.
  if (emailBackBtn) {
    emailBackBtn.addEventListener('click', function () {
      if (flowSteps.length) {
        currentIdx = flowSteps.length - 1;
        showStep(currentIdx);
      } else {
        showWelcome();
      }
    });
  }

  // Coerce the raw input to a clean text email: force to string, trim, lowercase
  // (so Jane@x.com and jane@x.com don't create duplicate profiles), drop any
  // internal whitespace, and strip characters that have no place in an email
  // address (incl. < > " ' that could carry markup).
  function sanitizeEmail(value) {
    return String(value == null ? '' : value)
      .trim()
      .toLowerCase()
      .replace(/\s+/g, '')
      .replace(/[<>"'`]/g, '');
  }

  // Loose email sanity check — Klaviyo does the authoritative validation, this
  // just stops obviously-empty/malformed submits from advancing the quiz.
  function isLikelyEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
  }

  // Subscribe the email to the quiz list WITH marketing consent via Klaviyo's
  // client-side Subscription API (public key, no backend). This is what lets the
  // flow actually deliver to brand-new visitors — track() alone can't grant
  // consent. Returns a promise that REJECTS if the request fails or Klaviyo
  // returns a non-2xx status, so the caller can block advancing + show an error.
  function subscribeToKlaviyoList(email) {
    if (!klaviyoPublicKey || !klaviyoListId) {
      return Promise.reject(new Error('Klaviyo public key / list ID not configured'));
    }
    var body = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'Wellness Quiz',
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email,
                properties: {
                  quiz_tags: buildQuizTags(),
                  results_url: currentResultsUrl(),
                  name: getQuizName()
                },
                subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
              }
            }
          }
        },
        relationships: { list: { data: { type: 'list', id: klaviyoListId } } }
      }
    };
    // Abort if Klaviyo hangs, so the button can't stay stuck in is-loading — the
    // rejection flows to submitCustomEmail's .catch (retry message + re-enable).
    var controller = (typeof AbortController !== 'undefined') ? new AbortController() : null;
    var timer = controller ? setTimeout(function () { controller.abort(); }, SUBSCRIBE_TIMEOUT_MS) : null;
    var opts = {
      method: 'POST',
      headers: { 'Content-Type': 'application/vnd.api+json', revision: '2026-04-15' },
      body: JSON.stringify(body)
    };
    if (controller) opts.signal = controller.signal;
    return fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + encodeURIComponent(klaviyoPublicKey), opts)
      .then(function (res) {
        if (timer) clearTimeout(timer);
        // Client subscription returns 202 Accepted on success. Anything else
        // (validation error, rate limit, server error) should be treated as a
        // failure so the user can retry rather than silently losing their email.
        if (!res.ok) {
          throw new Error('Klaviyo subscribe returned HTTP ' + res.status);
        }
        return res;
      }, function (err) {
        if (timer) clearTimeout(timer);
        throw (err && err.name === 'AbortError') ? new Error('Klaviyo subscribe timed out') : err;
      });
  }

  // Toggle the custom email form into / out of its in-flight state. While
  // submitting the button is truly disabled (no double-submit). When idle but the
  // consent box is unticked it gets the is-disabled CLASS — looks disabled yet
  // stays clickable, so a click can prompt the user to tick consent.
  function setEmailSubmitting(on) {
    if (emailSubmitBtn) {
      var blocked = !on && !!(emailConsent && !emailConsent.checked);
      emailSubmitBtn.disabled = on;
      emailSubmitBtn.classList.toggle('is-loading', on);
      emailSubmitBtn.classList.toggle('is-disabled', blocked);
      emailSubmitBtn.setAttribute('aria-disabled', blocked ? 'true' : 'false');
    }
    if (emailInput) emailInput.disabled = on;
  }
  // Re-evaluate the button state + clear the prompt when the consent box changes.
  if (emailConsent) {
    emailConsent.addEventListener('change', function () {
      setEmailSubmitting(emailSubmitting);
      if (emailConsent.checked && emailConsentErr) emailConsentErr.textContent = '';
    });
  }

  // Custom email form: captures the email, subscribes-with-consent, and only on a
  // SUCCESSFUL subscribe completes the quiz. submitQuiz() runs identifyInKlaviyo(),
  // which identifies the profile by this email and fires the "Completed Wellness
  // Quiz" track event that triggers the flow. On failure we surface an error and
  // stay on the step so the visitor can retry.
  function submitCustomEmail() {
    if (!emailInput || emailSubmitting) return;
    // Honeypot tripped → treat as a bot: skip the subscribe + flow-trigger
    // entirely, but still advance to results so a rare false-positive human
    // isn't blocked from seeing their matches.
    if (emailHoneypot && emailHoneypot.value) {
      submitQuiz();
      return;
    }
    // Consent box unticked → prompt to tick it (the button looks disabled but
    // stays clickable). To view results without emailing, use Skip.
    if (emailConsent && !emailConsent.checked) {
      if (emailConsentErr) emailConsentErr.textContent = CONSENT_PROMPT;
      emailConsent.focus();
      return;
    }
    var email = sanitizeEmail(emailInput.value);
    if (!isLikelyEmail(email)) {
      if (emailFormErr) emailFormErr.textContent = 'Please enter a valid email address.';
      emailInput.focus();
      return;
    }
    if (emailFormErr) emailFormErr.textContent = '';
    emailSubmitting = true;
    setEmailSubmitting(true);
    emailRequested = true;       // consented email request → allow the flow-trigger event
    capturedFormEmail = email;   // top-priority identity for resolveKlaviyoEmail()
    subscribeToKlaviyoList(email)
      .then(function () {
        // Advance to results. Leave the form disabled; the step is being torn down.
        emailSubmitting = false;
        submitQuiz();
      })
      .catch(function (err) {
        console.warn('[rl-quiz] klaviyo subscribe failed:', err);
        emailSubmitting = false;
        setEmailSubmitting(false);
        if (emailFormErr) {
          emailFormErr.textContent = "Sorry, we couldn't send your results just now. Please try again.";
        }
        if (emailInput) emailInput.focus();
      });
  }

  if (emailForm) {
    emailForm.addEventListener('submit', function (e) {
      e.preventDefault();
      submitCustomEmail();
    });
  }

  // Back button on the Dr/intro step - returns the user to the last question
  // so they can adjust answers; the in-flow nav/progress is restored.
  var introBackBtn = document.getElementById('rl-intro-back');
  if (introBackBtn) {
    introBackBtn.addEventListener('click', function () {
      pendingCardsHTML = null;
      if (flowSteps.length) {
        currentIdx = flowSteps.length - 1;
        showStep(currentIdx);
      } else {
        showWelcome();
      }
    });
  }

  // Restore the welcome name field from a previous session so returning
  // visitors don't have to retype it. Stored separately from quiz answers.
  restoreQuizName();

  // Restore from URL or localStorage. URL with no edit=1 jumps to results;
  // URL with edit=1 or localStorage restore lands on welcome with answers prefilled.
  var saved = loadAnswers();
  if (saved) {
    applySelection(decodeSelection(saved.encoded));
    refreshActiveStates();
    if (saved.source === 'url' && !saved.editMode) {
      submitQuiz(true);
    } else {
      showWelcome();
    }
  } else {
    refreshActiveStates();
    showWelcome();
  }
})();
